import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { DetailPageActionTypes } from '../actions/constants'
import { Reducer } from 'redux'
import { DetailPageActions } from '../actions'

export type CustomerPreferences = WpsTypes.atv.wps.CustomerBasedPreferencesOutputProps | null

const initialState: CustomerPreferences = null

export const reducer: Reducer<CustomerPreferences, DetailPageActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DetailPageActionTypes.STORE_MERGE:
      return action.payload.customerPreferences || state
    case DetailPageActionTypes.RESET_STORE:
      return initialState
    default:
      return state
  }
}
